
import { DefaultBackdropProps } from "../../components/default-backdrop";
import { DefaultDialogProps } from "../../components/default-dialog";
import { DefaultMessageProps, IErrorDetails } from "../../components/default-message";
import { ACTION_TYPES, useBaseLayoutDispatch } from "./base-layout-context";
import axios, { AxiosError } from 'axios';
import { IMessageResponse } from "../../../model/base/response/message-response";
import { getErrorMessage } from "../../../constants/error-messages.constants";

export const useBaseLayoutController = () => {
    const baseLayoutDispatch = useBaseLayoutDispatch();

    const handlerErrorShowMessage = (error: AxiosError) => {
        // Sempre limpar loading e backdrop
        showBackDrop(false);
        setLoading(false);

        // Extrair resposta do backend se disponível
        const backendResponse = error.response?.data as IMessageResponse | undefined;

        // Caso especial: 401 redireciona para login (manter comportamento atual)
        if (error.response?.status === 401) {
            window.location.href = `/?action=login`;
            return;
        }

        // Preparar detalhes de erro para exibição
        const errorDetails: IErrorDetails | undefined = backendResponse ? {
            traceId: backendResponse.traceId,
            code: backendResponse.code,
            detail: backendResponse.detail
        } : undefined;

        // Determinar mensagem a exibir (backend ou padrão)
        const statusCode = error.response?.status || 0;
        const userMessage = getErrorMessage(statusCode, backendResponse?.message);

        // Exibir mensagem com detalhes opcionais
        showMessage({
            open: true,
            message: userMessage,
            type: "error",
            errorDetails: errorDetails
        });
    }

    const showDialog = async (props: DefaultDialogProps) => {
        await baseLayoutDispatch({
            type: ACTION_TYPES.setDialogProps,
            payload: {
                ...props, open: true, onClose: () => {
                    baseLayoutDispatch({
                        type: ACTION_TYPES.setDialogProps,
                        payload: { ...props, open: false }
                    })
                }
            }
        });
    }

    const setLoading = async (loading: boolean) => {
        await baseLayoutDispatch({
            type: ACTION_TYPES.setLoading,
            payload: loading
        });
    }
    const showBackDrop = async (loading: boolean) => {
        setLoading(loading);
        await baseLayoutDispatch({
            type: ACTION_TYPES.setBackdropPros,
            payload: { open: loading } as DefaultBackdropProps
        });
    }

    const showMessage = async (props: DefaultMessageProps) => {
        await baseLayoutDispatch({
            type: ACTION_TYPES.setMessageProps,
            payload: {
                ...props, open: true, onClose: () => {
                    baseLayoutDispatch({
                        type: ACTION_TYPES.setMessageProps,
                        payload: { ...props, open: false }
                    })
                }
            }
        });
    }


    return {
        showDialog, showMessage, setLoading, showBackDrop, handlerErrorShowMessage
    };
}